import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';

function WalmartPalletLabelsTable(props) {

    const columns = [
        {
            field: 'internal_po_number',
            headerName: 'PO Number',
            flex: 1,
            minWidth: 175,
            editable: false
        },
        {
            field: 'case_pack_count',
            headerName: 'Case Pack Count',
            flex: 1,
            minWidth: 150,
            editable: false
        },
        {
            field: 'total_qty',
            headerName: 'Total Qty',
            flex: 1,
            minWidth: 125,
            editable: false
        },
        {
            field: 'pallet_count',
            headerName: 'Existing Pallet Count',
            flex: 1,
            minWidth: 175,
            editable: false
        },
        {
            field: 'additional_pallet_count',
            headerName: 'Additional Pallet Count',
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params) => {
                return (
                    <TextField
                        type="number"
                        size="small"
                        value={
                            props.additionalPalletCounts[
                                params.row.internal_po_number
                            ] || ""
                        }
                        onChange={(event) => {
                            props.setAdditionalPalletCounts(prev => ({
                                ...prev,
                                [params.row.internal_po_number]: event.target.value
                            }));
                        }}
                        inputProps={{
                            min: 0, onWheel: event => event.currentTarget.blur()
                        }}
                    />
                );
            }
        },
        {
            field: 'generate',
            headerName: 'Generate Labels',
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Button
                        variant="contained"
                        color="success"
                        disabled={props.isLoading}
                        onClick={() => {
                            props.generatePalletLabels(
                                params.row,
                                props.additionalPalletCounts[
                                    params.row.internal_po_number
                                ] || 0
                            );
                        }}
                    >
                        Generate Pallet Labels
                    </Button>
                );
            }
        }
    ];

    return (
        <Box className={props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box
                className={
                    props.isMobile
                        ? "mobile-table-box"
                        : "desktop-table-box"
                }
            >
                <DataGrid
                    className={
                        props.isMobile
                            ? "mobile-table"
                            : "desktop-table"
                    }
                    sx={{ height: "700px" }}
                    rows={props.orders}
                    columns={columns}
                    getRowId={(row) => row.internal_po_number}
                    rowsPerPageOptions={[25, 50, 100]}
                    checkboxSelection={false}
                />
            </Box>
        </Box>
    );
}

export default WalmartPalletLabelsTable;